import React, { useState } from 'react';

function TemperatureConverter() {
  const [value, setValue] = useState('');
  const [conversionType, setConversionType] = useState('fToC');
  const [result, setResult] = useState('');

  const conversions = [
    { id: 'fToC', name: 'Fahrenheit to Celsius', formula: val => (val - 32) * (5/9) },
    { id: 'cToF', name: 'Celsius to Fahrenheit', formula: val => (val * 9/5) + 32 },
    { id: 'cToK', name: 'Celsius to Kelvin', formula: val => val + 273.15 },
    { id: 'kToC', name: 'Kelvin to Celsius', formula: val => val - 273.15 },
    { id: 'fToK', name: 'Fahrenheit to Kelvin', formula: val => (val - 32) * (5/9) + 273.15 },
    { id: 'kToF', name: 'Kelvin to Fahrenheit', formula: val => (val - 273.15) * (9/5) + 32 }
  ];

  const handleConvert = () => {
    if (!value || isNaN(value)) {
      setResult('Please enter a valid number');
      return;
    }

    const conversion = conversions.find(c => c.id === conversionType);
    if (conversion) {
      const convertedValue = conversion.formula(parseFloat(value));
      
      // Get symbols based on temperature type
      let fromSymbol = '';
      let toSymbol = '';
      
      if (conversion.id.charAt(0) === 'f') fromSymbol = '°F';
      else if (conversion.id.charAt(0) === 'c') fromSymbol = '°C';
      else if (conversion.id.charAt(0) === 'k') fromSymbol = 'K';
      
      if (conversion.id.charAt(2) === 'F') toSymbol = '°F';
      else if (conversion.id.charAt(2) === 'C') toSymbol = '°C';
      else if (conversion.id.charAt(2) === 'K') toSymbol = 'K';
      
      setResult(`${value}${fromSymbol} = ${convertedValue.toFixed(2)}${toSymbol}`);
    }
  };

  return (
    <div className="converter">
      <h2>Temperature Converter</h2>
      <select value={conversionType} onChange={(e) => setConversionType(e.target.value)}>
        {conversions.map(conversion => (
          <option key={conversion.id} value={conversion.id}>
            {conversion.name}
          </option>
        ))}
      </select>
      <input
        type="number"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={`Enter ${conversions.find(c => c.id === conversionType).name.split(' to ')[0]}`}
      />
      <button onClick={handleConvert}>Convert</button>
      {result && <div className="result">{result}</div>}
    </div>
  );
}

export default TemperatureConverter;
